export class ProofingConfigModel {
  ProofingListAPI: string = "";
  UpdateAPI: string = "";
  ConfigTypeListAPI: string = "";
  ProofingApplyToListAPI: string = "";
  ProofingStageListAPI: string = "";
  ProofingByIdAPI: string = "";
  DeleteProofingAPI: string = "";
  ProofingCountryListAPI: any;
  ProofingLanguageListAPI: any;
  GetProofingType: any;
  GetMailBody: any;
  GetDynamicTagListAPI: any;
  GetProofingConfigData: string = "";
  GetRemindMailBody: any = "";
  GetReminderCountMailBody: any;
  GetConfirmationMailBody: any;
  CloneProofingConfig: any;
}


